import { Dialog, DialogContent } from "@mui/material";
import Box from "@mui/material/Box";

export default function GalleryModal({ openGallery, setOpenGallery, imgSrc }) {
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="md"
        open={openGallery}
        onClose={() => {
          setOpenGallery(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogContent>
          <Box>
            <img src={imgSrc} alt="hawking" style={{ width: "100%", height: "400px" }} />
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
